<template>
  <el-container>
    <el-main>
      <el-row>
        <el-col :span="20">
          <el-form :inline="true">
            <el-form-item>
              <div class="btns">
                <el-button type="primary" @click="add">添加屏蔽词</el-button>
                <el-upload action="" :show-file-list="false" type="primary" :http-request="onUpload"><el-button type="primary">导入屏蔽词</el-button></el-upload>
              </div>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-table :data="records" border>
        <el-table-column label="屏蔽词名称" prop="word"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">编辑</el-button>
            <el-button type="danger" @click="del">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-dialog
      title="添加屏蔽词"
      :visible.sync="formVisible"
      width="600px">
      <el-form ref="formData" :model="formData" label-width="100px">
        <el-form-item label="屏蔽词">
          <el-input v-model="formData.word"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="primary" @click="onSave">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import request from '@/utils/request'
import upload from '@/utils/upload'
export default {
  name: 'Roles',
  data () {
    return {
      records: [],
      formData: {
        word: ''
      },
      formVisible: false
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getList () {
      request.get('keywords').then(res => {
        this.records = res.data
      })
    },
    add () {
      this.modalTit = '添加'
      this.formVisible = true
    },
    edit (row) {
      this.modalTit = '编辑'
      this.formData = row
      this.formVisible = true
    },
    onCancel () {
      console.log(this.$refs)
      this.$refs.formData.resetFields()
      this.formVisible = false
    },
    onSave () {
      this.formData.permissions = this.rolePermissions
      if (this.currentRow) {
        this.formData.parent_id = this.currentRow.id
      }
      if (this.formData.id) {
        request.put(`keywords/${this.formData.id}`, this.formData).then(() => {
          this.$refs.formData.resetFields()
          this.getList()
          this.formVisible = false
        })
      } else {
        request.post(`keywords`, this.formData).then(() => {
          this.$refs.formData.resetFields()
          this.getList()
          this.formVisible = false
        })
      }
    },
    del () {
      this.$confirm('确定删除此项吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    onUpload(obj) {
      const upData = new FormData();
      upData.append('words', obj.file);
      upload.post('keywords/batch', upData).then(() => {
        this.getList()
      })
    },
  }
}
</script>

<style scoped>
.el-aside {
  border-right: 1px solid #ddd;
}
.list-group li {
  cursor: pointer;
  padding: 0 10px;
}
.list-group li:hover, .list-group li.active {
  background-color: #ecf5ff;
}
.btns{
  display: flex;
  gap: 10px;
}
</style>
